import { useState } from 'react';

import { Info } from '@crehana/compass.icons.outline/v2/info';
import { BasicPopover } from '@crehana/compass.ui/v3/popover';
import { BasicTooltip } from '@crehana/compass.ui/v3/tooltip';

import { type TKeys, useTranslation } from '../i18n';

const STATUS_ITEMS: Array<{ colorClass: string; labelKey: TKeys }> = [
  {
    colorClass: 'tw-bg-[var(--cds-chart-series3-primary)]',
    labelKey: 'a_tiempo',
  },
  {
    colorClass: 'tw-bg-[var(--cds-chart-series5-primary)]',
    labelKey: 'aceptable',
  },
  {
    colorClass: 'tw-bg-[var(--cds-chart-series6-secondary)]',
    labelKey: 'retardo_o_falta',
  },
  {
    colorClass: 'tw-bg-[var(--cds-chart-series4-primary)]',
    labelKey: 'salida_anticipada',
  },
  {
    colorClass: 'tw-bg-[var(--cds-chart-series2-primary)]',
    labelKey: 'fuera_de_horario',
  },
  {
    colorClass: 'tw-bg-[var(--cds-chart-neutral)]',
    labelKey: 'sin_calculo',
  },
];

export const StatusLegend = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const content = (
    <div className="tw-flex tw-flex-col tw-gap-0.8">
      {STATUS_ITEMS.map(item => (
        <div key={item.labelKey} className="tw-flex tw-items-center tw-gap-0.8">
          <span
            className={`tw-w-1 tw-h-1 tw-rounded-full tw-shrink-0 ${item.colorClass}`}
          />
          <span className="tw-cds-font-body-03">{t(item.labelKey)}</span>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <BasicPopover content={content} open={open} onOpenChange={setOpen}>
        <button
          type="button"
          aria-label="Status legend"
          className="tw-w-1.6 tw-h-1.6 sm:tw-hidden"
          onClick={() => setOpen(true)}
        >
          <Info size={16} />
        </button>
      </BasicPopover>

      <BasicTooltip content={content} side="right" align="center">
        <button
          type="button"
          aria-label="Status legend"
          className="tw-w-1.6 tw-h-1.6 tw-hidden sm:tw-block"
        >
          <Info size={16} />
        </button>
      </BasicTooltip>
    </>
  );
};
